/* CurvaShop – "Aggiungi al carrello" dalle schede prodotto (home e collezioni) */
(function () {
  'use strict';
  var I18N = (document.getElementById('cs-i18n') || { dataset: {} }).dataset;
  function tr(k, fb) { return I18N[k] || fb; }
  function root() {
    var r = window.Shopify && Shopify.routes && Shopify.routes.root;
    if (!r) r = '/';
    return r.charAt(r.length - 1) === '/' ? r : r + '/';
  }
  function cartUrl() { return (window.CS && CS.cartUrl) || root() + 'cart'; }
  function esc(s) { var d = document.createElement('span'); d.textContent = s; return d.innerHTML; }

  function setCount() {
    if (window.CS && typeof CS.refreshCount === 'function') return CS.refreshCount();
    return fetch(root() + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        Array.prototype.forEach.call(document.querySelectorAll('[data-cart-count]'), function (el) { el.textContent = c.item_count; });
      });
  }

  function msg(card, text, isErr) {
    var m = card.querySelector('[data-qa-msg]');
    if (!m) return;
    m.textContent = text || '';
    m.classList.toggle('is-err', !!isErr);
  }

  function closePicker(card) {
    var pick = card.querySelector('[data-qa-pick]');
    var btn = card.querySelector('[data-qa-add]');
    if (pick) pick.hidden = true;
    if (btn && btn.hasAttribute('aria-expanded')) btn.setAttribute('aria-expanded', 'false');
  }

  function add(card, id, srcBtn) {
    var btn = card.querySelector('[data-qa-add]');
    var label = tr('addToCart', 'Aggiungi al carrello');
    if (!btn || btn.getAttribute('data-busy')) return;
    btn.setAttribute('data-busy', '1');
    btn.disabled = true;
    if (srcBtn) srcBtn.disabled = true;
    btn.textContent = tr('adding', 'Aggiunta in corso…');
    msg(card, '');
    fetch(root() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: +id, quantity: 1 }] })
    })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function () {
        closePicker(card);
        btn.textContent = tr('added', 'Aggiunta ✓');
        btn.classList.add('is-added');
        msg(card, tr('added', 'Aggiunta ✓'));
        setCount();
        var title = card.getAttribute('data-title') || '';
        if (window.CS && typeof CS.toast === 'function') {
          CS.toast(esc(title) + ' ' + tr('addedToCart', 'aggiunta al carrello') + ' <a href="' + cartUrl() + '">' + tr('viewCart', 'Vedi carrello') + '</a>');
        }
        document.dispatchEvent(new CustomEvent('curvashop:cart-added', { detail: { id: +id } }));
        setTimeout(function () {
          btn.textContent = label;
          btn.classList.remove('is-added');
          msg(card, '');
        }, 2500);
      })
      .catch(function (err) {
        btn.textContent = label;
        msg(card, (err && (err.description || err.message)) || tr('addError', 'Non è stato possibile aggiungere la maglia. Riprova.'), true);
      })
      .then(function () {
        btn.disabled = false;
        btn.removeAttribute('data-busy');
        if (srcBtn) srcBtn.disabled = false;
      });
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var addBtn = t.closest('[data-qa-add]');
    var sizeBtn = t.closest('.cs-qa-v[data-qa-variant]');
    var card = (addBtn || sizeBtn) && (addBtn || sizeBtn).closest('[data-qa-card]');
    if (!card) return;
    e.preventDefault();
    if (sizeBtn) { if (!sizeBtn.disabled) add(card, sizeBtn.getAttribute('data-qa-variant'), sizeBtn); return; }
    var single = addBtn.getAttribute('data-qa-variant');
    if (single) { add(card, single); return; }
    var pick = card.querySelector('[data-qa-pick]');
    if (!pick) return;
    var open = pick.hidden;
    pick.hidden = !open;
    addBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (open) {
      msg(card, '');
      var first = pick.querySelector('.cs-qa-v:not([disabled])');
      if (first) first.focus();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape' || !e.target.closest) return;
    var card = e.target.closest('[data-qa-card]');
    var pick = card && card.querySelector('[data-qa-pick]');
    if (pick && !pick.hidden) {
      closePicker(card);
      var b = card.querySelector('[data-qa-add]');
      if (b) b.focus();
    }
  });
})();
